var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRows = function SvgIconRows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.25A1.75 1.75 0 0 0 2.75 6v3.75c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75V6a1.75 1.75 0 0 0-1.75-1.75zm.25 5.25V6.25h14.5V9.5zM4.5 12.5a1.75 1.75 0 0 0-1.75 1.75V18c0 .966.784 1.75 1.75 1.75h15A1.75 1.75 0 0 0 21.25 18v-3.75a1.75 1.75 0 0 0-1.75-1.75zm.25 5.25V14.5h14.5v3.25z"
  }))));
};
export default SvgIconRows;